import * as actions from '../actions';

const initialState = {
  cancelModalVisible: false,
  volumeModalVisible: false,
  volumeModalSeen: false,
  coldVolumeModalVisible: false,
  coldVolumeModalSeen: false,
  clearModalVisible: false,
  saveButtonModal: false,
  exp98SaveButtonModal: false,
  saveThresholdModal: false,
  exp98SaveThresholdModal: false,
  cutoffModal: false,
};

const modals = (state = initialState, action) => {
  switch (action.type) {
    case actions.TOGGLE_CANCEL_MODAL:
      return Object.assign({}, state, {
        cancelModalVisible: !state.cancelModalVisible,
      });
    case actions.OPEN_VOLUME_MODAL:
      ga('send', 'event', 'modal-open', 'volume-modal-open');
      return Object.assign({}, state, {
        volumeModalVisible: true,
        volumeModalSeen: true,
      });
    case actions.CLOSE_VOLUME_MODAL:
      return Object.assign({}, state, { volumeModalVisible: false });
    case actions.OPEN_COLD_VOLUME_MODAL:
      ga('send', 'event', 'modal-open', 'cold-volume-modal-open');
      return Object.assign({}, state, {
        coldVolumeModalVisible: true,
        coldVolumeModalSeen: true,
      });
    case actions.CLOSE_COLD_VOLUME_MODAL:
      return Object.assign({}, state, { coldVolumeModalVisible: false });
    case actions.TOGGLE_CLEAR_MODAL:
      return Object.assign({}, state, {
        clearModalVisible: !state.clearModalVisible,
      });
    case actions.TOGGLE_EXP98_SAVE_BUTTON_MODAL:
      return Object.assign({}, state, {
        exp98SaveButtonModal: !state.exp98SaveButtonModal,
      });
    case actions.TOGGLE_SAVE_THRESHOLD_MODAL:
      return Object.assign({}, state, {
        saveThresholdModal: !state.saveThresholdModal,
      });
    case actions.TOGGLE_EXP98_SAVE_THRESHOLD_MODAL:
      return Object.assign({}, state, {
        exp98SaveThresholdModal: !state.exp98SaveThresholdModal,
      });
    case actions.TOGGLE_CUTOFF_MODAL:
      if (state.cutoffModal) {
        window.onbeforeunload = null;
        window.location = '/upcoming/';
        return;
      }
      return Object.assign({}, state, { cutoffModal: !state.cutoffModal });
    default:
      return state;
  }
};

export default modals;
